import { createRepo, type RepoAsync, rememberUserLocal, getRememberedName } from "./repoToggle";
import { IUser, newUser } from "./IUser";
import './LoginManager.css';

export class LoginManager {
    loginDlg!: HTMLDivElement; // login dialog
    currentUser!: IUser; // null when Guest
    repo: RepoAsync;

    constructor(user: IUser, repo: RepoAsync) {
        this.currentUser = user;
        this.repo = repo;
    }

    private async checkRememberedUser() {
        const remembered = getRememberedName();
        if (remembered) {
            return await this.repo.getUserByName(remembered);
        }
    }

    async initLoginFlow() : Promise<{ user: IUser; isNewUser: boolean }> {
          // First check for remembered user
        const rememberedUser = await this.checkRememberedUser();
        if (rememberedUser) {
            // Calculate fresh PPR from games (excludes tournaments)
            rememberedUser.avgPPR = await this.repo.calculateUserPPR(rememberedUser.id);
            this.currentUser = rememberedUser;
            return { user: rememberedUser, isNewUser: false };
        }

        return new Promise<{ user: IUser; isNewUser: boolean }>((resolve) => {
            // Login dialog
            this.loginDlg = document.createElement('div');
            this.loginDlg.id = 'login-splash';
            this.loginDlg.innerHTML = `
            <div class="login-container">
                <div class="logo-placeholder">SKROLLROLLR</div>
                <form id="loginForm">
                    <input id="uname" type="text" placeholder="enter your name" autofocus maxlength="12"/>
                    <button type="submit">Skroll!</button>
                </form>
            </div>
            <div class="login-footer">made with ❤️ & 🥲 in the chicago burbs</div>
            `;

            document.body.appendChild(this.loginDlg);

            const show = () => {
                this.loginDlg.style.display = 'flex';
                // We need to trigger the display before adding the class for the transition to work
                setTimeout(() => {
                    this.loginDlg.classList.add('show');
                }, 10);
            }
            const hide = () => {
                this.loginDlg.classList.remove('show');
                // Wait for the transition to finish before setting display to none
                setTimeout(() => {
                    this.loginDlg.style.display = 'none';
                }, 500); // Match this to the transition duration in CSS
            }

            const form = this.loginDlg.querySelector<HTMLFormElement>('#loginForm')!;
            const uname = this.loginDlg.querySelector<HTMLInputElement>('#uname')!;

            const setCurrentUser = (u: IUser, isNew: boolean) => {
                this.currentUser = u; // null means Guest
                hide();
                resolve({ user: this.currentUser, isNewUser: isNew });
                return this.currentUser;
            };

            show();

            form.onsubmit = async (e) => {
                e.preventDefault();

                const name = uname.value.trim();
                if (!name) return;

                let user = await this.repo.getUserByName(name);
                const isNewUser = !user;
                if (!user) { user = await this.repo.upsertUser(newUser(name)); }

                // Calculate fresh PPR from games (excludes tournaments)
                user.avgPPR = await this.repo.calculateUserPPR(user.id);

                // For simplicity, we will always remember the user.
                rememberUserLocal(user.id, user.userName);
                return setCurrentUser(user, isNewUser);
            };

        });


    }

}